import React, {useEffect} from 'react'
import { MenuHeaderContainer } from '../../containers/visualization/MenuHeader'
import { ResultsContainer } from '../../containers/visualization/Results'
import { SectionsFooterContainer } from '../../containers/visualization/SectionsFooter';
import { FooterContainer } from '../../containers/visualization/Footer';
import NoWorkingPage from './NoWorkingPage';
import { useHistory } from 'react-router-dom'

export default function Results({accessToken, name, email, isActive, isSuperuser, websiteId}) {
    let history = useHistory()
  
    useEffect(() => {
      if (accessToken) {
          //if account is active
          if(isActive === undefined){

        }else{
            if(isActive ){
    
            }
            else {
                history.push(`/account-not-active`)
            }
        }
      }
  }, [
      accessToken,
      email,
      isActive,
      isSuperuser
  ])
    return (
        <>
        {isActive &&
    <div>

        <MenuHeaderContainer pageName={'Results'}  email={email} name={name} accessToken={accessToken} websiteId={websiteId}/>
        <ResultsContainer email={email} name={name} accessToken={accessToken} websiteId={websiteId}/>
        <SectionsFooterContainer pageName={'Results'}  email={email} name={name} accessToken={accessToken}/>
        <FooterContainer />
        <NoWorkingPage />
    </div>}
    </>
    )
}

